import { render, staticRenderFns } from "./coach_routines.vue?vue&type=template&id=c60ddc8c&scoped=true"
import script from "./coach_routines.vue?vue&type=script&lang=js"
export * from "./coach_routines.vue?vue&type=script&lang=js"
import style0 from "./coach_routines.vue?vue&type=style&index=0&id=c60ddc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ddc8c",
  null
  
)

export default component.exports